import React, { Component } from 'react';
import { string, arrayOf, object, bool } from 'prop-types';
import classnames from 'classnames';

import Carousel from 'common/Carousel/Carousel';
import HubCard from './HubCard/HubCard';
import { isMobileHOC } from 'common/utils';

import styles from './HubBanner.css';

class HubBanner extends Component {
  constructor (props) {
    super(props);

    this.state.totalSlides = props.items.length;
  }

  static propTypes = {
    className: string,
    highlighted: string,
    title: string.isRequired,
    description: string.isRequired,
    items: arrayOf(object).isRequired,
    isMobile: bool
  };

  state = {
    activeSlide: null,
    totalSlides: null
  }

  swiper = null;

  onMountSwiper = (instance) => {
    this.swiper = instance;

    this.getSwiperDetails();

    this.swiper.on('slideChange', this.getSwiperDetails); 
  }

  onDismountSwiper = () => {
    this.swiper.off('slideChange', this.getSwiperDetails);
  }

  getSwiperDetails = () => this.setState({ activeSlide: this.swiper.realIndex + 1 });

  renderCardsList = () => (
    <ul className={styles.content}>
      {this.renderCards()}
    </ul>
  );

  renderCardsSlider = () => {
    const options = {
      unit: true,
      loop: true,
      spaceBetween: 30,
      width: 217
    };

    return (
      <Carousel options={options} onMount={this.onMountSwiper} onDismount={this.onDismountSwiper}>
        {this.renderCards()}
      </Carousel>
    );
  };

  renderCards = () => {
    const { items, isMobile } = this.props;

    return items.map((item, i) => 
      <li className={classnames(styles.cardWrapper, { 'swiper-slide': isMobile })} key={`hubCard-${i}`}>
        <HubCard {...item} />
      </li>
    );  
  }

  render () {
    const { activeSlide, totalSlides } = this.state;
    const { className, highlighted, title, description, isMobile } = this.props;

    return (
      <section className={classnames(styles.wrapper, className)}>
        <div className={styles.header}>
          <h5 className={styles.title}>
            {highlighted && <span className={styles.highlight}>{highlighted} </span>}
            {title}
          </h5>
          <p className={styles.description}>
            {description}
          </p>
        </div>
        {
          activeSlide &&
            <div className={styles.slideDescription}>
              <span>{activeSlide}</span> / {totalSlides}
            </div>
        }
        { isMobile ? this.renderCardsSlider() : this.renderCardsList() }
      </section>
    );
  }
}

export default isMobileHOC(HubBanner);


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HubBanner/HubBanner.js